import PostCoverBlock from "./PostCoverBlock";

export default class CoverBlockHome extends PostCoverBlock {
    /**
     * @param {HTMLElement} element
     */
    constructor(element) {
        super(element);
    }

    /**
     * Kijkt of het element een instantie van dit object moet krijgen.
     *
     * @param {HTMLElement} element
     *
     * @returns {boolean}
     */
    static is(element) {
        return (element.classList.contains('wp-block-cover') && element.classList.contains('is-style-home'));
    }
}